import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { AUTO_BID_API_BASE_URL } from '../api-base-url.token';
import { AutoBidInstructionResponseDto } from '../schemas/auto-bid-instruction-response.dto';
import { ConfigureAutoBidInstructionRequestDto } from '../schemas/configure-auto-bid-instruction-request.dto';

@Injectable({ providedIn: 'root' })
export class AutoBidInstructionsApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUTO_BID_API_BASE_URL)}/AutoBidInstruction`;

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', String(id)))
            .build()
            .send();
    }

    configure(payload: ConfigureAutoBidInstructionRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/configure`)
            .put(payload)
            .json<AutoBidInstructionResponseDto>()
            .build()
            .send();
    }

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<AutoBidInstructionResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', String(tradingProcedureId)))
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<AutoBidInstructionResponseDto>()
            .withHttpParams(new HttpParams().set('id', String(id)))
            .build()
            .send();
    }

    getByLotId(lotId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getByLotId`)
            .get()
            .json<AutoBidInstructionResponseDto>()
            .withHttpParams(new HttpParams().set('lotId', String(lotId)))
            .build()
            .send();
    }
}
